const initCatalogCategoriesScroll = () => {
  // Проверяем ширину экрана - работаем только для разрешений больше 768px
  if (window.innerWidth <= 768) return;

  const wrappers = document.querySelectorAll(".catalog-page__categories-wrapper");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const list = wrapper.querySelector(".catalog-page__categories");
    const btnRight = wrapper.querySelector(".catalog-page__categories-btn:not(.catalog-page__categories-btn--left)");
    const btnLeft = wrapper.querySelector(".catalog-page__categories-btn--left");
    if (!list || !btnRight) return;

    // Проверка на переполнение контента
    const hasOverflow = () => {
      return list.scrollWidth > list.clientWidth;
    };

    // Функция для показа/скрытия кнопок
    const toggleButtons = () => {
      const overflow = hasOverflow();
      if (overflow) {
        btnRight.style.display = "";
        if (btnLeft) btnLeft.style.display = "";
      } else {
        btnRight.style.display = "none";
        if (btnLeft) btnLeft.style.display = "none";
      }
    };

    const updateState = () => {
      // Проверяем ширину экрана перед обновлением состояния
      if (window.innerWidth <= 768) return;
      
      // Проверяем переполнение и показываем/скрываем кнопки
      toggleButtons();
      
      // Если нет переполнения, выходим
      if (!hasOverflow()) return;
      
      // проверяем, проскроллено ли вправо (с небольшой погрешностью)
      const hasLeft = list.scrollLeft > 1;
      if (hasLeft) {
        wrapper.classList.add("has-left-overlay");
      } else {
        wrapper.classList.remove("has-left-overlay");
      }
    };

    btnRight.addEventListener("click", (e) => {
      // Проверяем ширину экрана перед обработкой клика
      if (window.innerWidth <= 768) return;
      
      e.preventDefault();
      const viewportWidth = list.clientWidth;
      // шаг прокрутки ~80% видимой ширины
      const step = Math.max(200, Math.round(viewportWidth * 0.8));
      list.scrollBy({ left: step, behavior: "smooth" });
    });

    if (btnLeft) {
      btnLeft.addEventListener("click", (e) => {
        // Проверяем ширину экрана перед обработкой клика
        if (window.innerWidth <= 768) return;
        
        e.preventDefault();
        const viewportWidth = list.clientWidth;
        const step = Math.max(200, Math.round(viewportWidth * 0.8));
        list.scrollBy({ left: -step, behavior: "smooth" });
      });
    }

    list.addEventListener("scroll", updateState, { passive: true });
    
    // Отслеживаем изменения размера окна для проверки переполнения
    const resizeObserver = new ResizeObserver(() => {
      updateState();
    });
    resizeObserver.observe(list);
    
    // начальная инициализация
    updateState();
  });
};

initCatalogCategoriesScroll();

// Плавное скрытие/показ фильтров
const initCatalogFilters = () => {
  const filterTitles = document.querySelectorAll(".catalog-page__content-filter-body-item-title");
  if (!filterTitles.length) return;

  filterTitles.forEach((title) => {
    title.addEventListener("click", () => {
      const item = title.closest(".catalog-page__content-filter-body-item");
      if (!item) return;

      item.classList.toggle("is-collapsed");
    });
  });
};

initCatalogFilters();

// Price range slider
const initPriceRange = () => {
  const priceRanges = document.querySelectorAll(".price-range");
  if (!priceRanges.length) return;

  priceRanges.forEach((rangeContainer) => {
    const minRange = rangeContainer.querySelector(".price-range__range--min");
    const maxRange = rangeContainer.querySelector(".price-range__range--max");
    const minInput = rangeContainer.querySelector(".price-range__input--min");
    const maxInput = rangeContainer.querySelector(".price-range__input--max");
    const slider = rangeContainer.querySelector(".price-range__slider");

    if (!minRange || !maxRange || !minInput || !maxInput || !slider) return;

    const min = parseFloat(minRange.min);
    const max = parseFloat(minRange.max);

    const updateMinValue = () => {
      const minVal = parseFloat(minRange.value);
      const maxVal = parseFloat(maxRange.value);
      
      if (minVal > maxVal) {
        minRange.value = maxVal;
        minInput.value = maxVal;
      } else {
        minInput.value = minVal;
      }
      updateTrack();
    };

    const updateMaxValue = () => {
      const minVal = parseFloat(minRange.value);
      const maxVal = parseFloat(maxRange.value);
      
      if (maxVal < minVal) {
        maxRange.value = minVal;
        maxInput.value = minVal;
      } else {
        maxInput.value = maxVal;
      }
      updateTrack();
    };

    const updateTrack = () => {
      const minVal = parseFloat(minRange.value);
      const maxVal = parseFloat(maxRange.value);
      const minPercent = ((minVal - min) / (max - min)) * 100;
      const maxPercent = ((maxVal - min) / (max - min)) * 100;
      
      slider.style.setProperty("--min-percent", `${minPercent}%`);
      slider.style.setProperty("--max-percent", `${maxPercent}%`);
    };

    const updateFromInput = (input, range) => {
      const value = parseFloat(input.value);
      if (isNaN(value)) return;
      
      const clampedValue = Math.max(min, Math.min(max, value));
      range.value = clampedValue;
      input.value = clampedValue;
      
      if (input === minInput) {
        updateMinValue();
      } else {
        updateMaxValue();
      }
    };

    minRange.addEventListener("input", updateMinValue);
    maxRange.addEventListener("input", updateMaxValue);
    minInput.addEventListener("blur", () => updateFromInput(minInput, minRange));
    maxInput.addEventListener("blur", () => updateFromInput(maxInput, maxRange));
    minInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        updateFromInput(minInput, minRange);
        minInput.blur();
      }
    });
    maxInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        updateFromInput(maxInput, maxRange);
        maxInput.blur();
      }
    });

    // Начальная инициализация
    updateTrack();
  });
};

initPriceRange();

// Управление header при открытии фильтра
const initFilterHeaderControl = () => {
  const filterModal = document.getElementById("filter-modal");
  const header = document.querySelector(".header");
  const menuButton = document.querySelector("[data-menu]");
  
  if (!filterModal || !header || !menuButton) return;

  // Функция для обновления состояния header
  const updateHeaderState = () => {
    const isFilterOpen = filterModal.classList.contains("is-open");
    
    if (isFilterOpen) {
      // Скрываем bottom и показываем крестик
      header.classList.add("header--filter-open");
    } else {
      // Показываем bottom и показываем burger
      header.classList.remove("header--filter-open");
    }
  };

  // Отслеживаем изменения класса is-open на модалке
  const observer = new MutationObserver(updateHeaderState);
  observer.observe(filterModal, {
    attributes: true,
    attributeFilter: ["class"]
  });

  // Обработчик клика на data-menu для закрытия фильтра
  // Используем capture phase, чтобы перехватить событие до обработчика меню
  menuButton.addEventListener("click", (e) => {
    if (header.classList.contains("header--filter-open")) {
      e.preventDefault();
      e.stopPropagation();
      // Останавливаем все последующие обработчики на этом элементе
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      
      // Закрываем фильтр через универсальную систему модалок
      const closeButton = filterModal.querySelector("[data-modal-close]");
      if (closeButton) {
        // Симулируем клик на кнопку закрытия
        closeButton.click();
      } else {
        // Если нет кнопки закрытия, создаем событие для универсальной системы
        const closeEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        });
        filterModal.dispatchEvent(closeEvent);
      }
      return false;
    }
  }, true); // Используем capture phase

  // Начальное состояние
  updateHeaderState();
};

initFilterHeaderControl();

